import React, { lazy } from "react";

const LazyCorrections = lazy(() => import("./Corrections"));

const Corrections = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyCorrections {...props} />;

export default Corrections;
